import configCallCenterHttpService from "../_services/configCallCenterHttpService"
import { GET_CONFIG, GET_TAGS } from "./mutation-types"

export default {
    listarconfig: async ({ commit }) => {
      try {
        const response = await configCallCenterHttpService.getConfig()
        commit(GET_CONFIG, response.data)
      } catch (e) {
        console.log(e.message)
      }
    },
    listartags: async ({ commit }) => {
      try {
        const response = await configCallCenterHttpService.getTags()
        commit(GET_TAGS, response.data)
      } catch (e) {
        console.log(e.message)
      }
    },
}
